// extracted by mini-css-extract-plugin
module.exports = {"info-banner":"info-banner__info-banner___idp8v","icon-container":"info-banner__icon-container___M2B8_","content-wrapper":"info-banner__content-wrapper___hzKxy"};